export default __webpack_public_path__ + "static/media/nft7.06957d2d.jpeg";